import { render, staticRenderFns } from "./ConfirmBuyPoint.vue?vue&type=template&id=1648ef60&scoped=true&"
import script from "./ConfirmBuyPoint.vue?vue&type=script&lang=js&"
export * from "./ConfirmBuyPoint.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmBuyPoint.vue?vue&type=style&index=0&id=1648ef60&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1648ef60",
  null
  
)

export default component.exports